import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'
import VueCookies from 'vue-cookies'

Vue.use(Vuex);

export const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    status: "",
    isAuthenticated: false,
    user: "",
    role: "",
    lastWithdrawRun: "",
    referrer: "",
    haveAccount: false,
    unlinkLinkedin: false,
    haveAccountInstagram: false,
    isBlocked: true,
    automatedYsyActions: [],
    notificationActionYsy: [],
    emailLinkedin: "",
    emailInstagram: [],
    durationToWithdraw: '',
    dictConfigurationLimit: '',
    maintenanceYsYSalesNavigator:false,
  },

  mutations: {
    setUser(state, user) {
      state.user = user
    },
    addInstagramAccount(state, email) {
      state.emailInstagram.push(email)
    },
    removeInstagramAccount(state, email) {
      const index = state.emailInstagram.indexOf(email);
      if (index > -1) {
        state.emailInstagram.splice(index, 1);
      }
    },
    setLastRun(state, lastWithdrawRun) {
      state.lastWithdrawRun = lastWithdrawRun
    },
    setDurationToWithdraw(state, durationToWithdraw) {
      state.durationToWithdraw = durationToWithdraw
    },
    setDictConfigurationLimit(state, dictConfigurationLimit) {
      state.dictConfigurationLimit = dictConfigurationLimit
    },
    changeDictConfigurationLimit(state, payload) {
      if (payload["rule"] === '+') {
        state.dictConfigurationLimit[payload["mode"]].count = payload["previous"] + 1
      } else {
        state.dictConfigurationLimit[payload["mode"]].count = payload["previous"] - 1
      }
    },

    setHaveAccount(state, value) {
      state.haveAccount = value;
    },
    setValueHaveAccount(state, value) {
      state.haveAccount = value;
    },
    setUnlinkLinkedIn(state, value) {
      state.haveAccount = !value;
      state.unlinkLinkedin = true;
    },
    setLinkLI(state) {
      state.unlinkLinkedin = false;
    },
    setHaveAccountInstagram(state) {
      state.haveAccountInstagram = true;
    },
    pushAutomatedAction(state, action) {
      state.automatedYsyActions.push(action)
    },
    popAutomatedAction(state, action) {
      state.automatedYsyActions = state.automatedYsyActions.filter(e => e !== action);
    },
    pushNotificationActionYsy(state, action) {
      state.notificationActionYsy.push(action)
    },
    popNotificationActionYsy(state, action) {
      state.notificationActionYsy = state.notificationActionYsy.filter(e => e !== action);
    },
    setEmailLinkedin(state, emailLinkedin) {
      state.emailLinkedin = emailLinkedin;
    },
    setReferrer(state, referrer) {
      state.referrer = referrer;
    },
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, payload) {

      state.status = "success";
      state.isAuthenticated = true;
      state.user = payload.user;
      state.role = payload.role;
      state.referrer = payload.referrer;
      state.automatedYsyActions = payload.automatedYsyActions;
      state.notificationActionYsy = payload.notificationActionYsy;
      state.lastWithdrawRun = payload.lastWithdrawRun;
      state.emailLinkedin = payload.emailLinkedin;
      state.emailInstagram = payload.emailInstagram;
      state.haveAccount = payload.haveAccount;
      state.haveAccountInstagram = payload.haveAccountInstagram;
      state.isBlocked = payload.isBlocked
      var dateCookieExpire = new Date();
      dateCookieExpire.setDate(dateCookieExpire.getDate() + 1);
      VueCookies.set("ysy_jwt", localStorage.id_token, dateCookieExpire)
    },

    unlock_account(state) {
      state.isBlocked = false
    },
    lock_ysy_account(state) {
      state.isBlocked = true
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      store.replaceState({})
      VueCookies.remove("ysy_jwt")
      console.log('clear vuex')
    }
  },
  actions: {
    logout({commit}) {
      return new Promise((resolve, reject) => {
        commit('logout')
        resolve()
      })
    }
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    getUser: state => state.user,
    getEmailLinkedin: state => state.emailLinkedin,
    getAutomatedYsyActions: state => state.automatedYsyActions,
    getNotificationActionYsy: state => state.notificationActionYsy,
    getEmailInstagram: state => state.emailInstagram,
    getStateLinkedin: state => state,
    getHaveAccount: state => state.haveAccount,
    getHaveAccountInstagram: state => state.haveAccountInstagram,
    isBlocked: state => state.isBlocked,
    getUserRole: state => state.role,
    getReferrer: state => state.referrer,
    getDictConfigurationLimit: state => state.dictConfigurationLimit,
    getStateUnlinkLI: state => state.unlinkLinkedin,
    getMaintenanceYsYSalesNavigator: state => state.maintenanceYsYSalesNavigator,
  }
});
